export const IGNORED_FILTERS_FOR_MARK = [
  'page',
  'pageSize',
  'sortField',
  'order',
  'searchTerm',
  'date',
  'selectedClientId'
];
